/*
  src/redux/errors/reducer.js

  Created by erikchristensen on 10/19/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

import update from 'immutability-helper';
import {
  ERROR_DISMISSED
} from './constants';

const initialState = [];

export default function(state=initialState,action){
  if(action.type === ERROR_DISMISSED){
    return update(state,{
      $apply:(errs) => errs.splice(action.payload,0)
    });

  } else if(action.error){
    return update(state,{
      $push:[action.payload]
    });

  } else {
    return update(state,{});
  }
}



// WEBPACK FOOTER //
// ./src/shared/redux/errors/reducer.js